<template>
  <div>
    <Toolbar class="mb-4">
      <template #left>
        <Button
          label="Add New"
          icon="pi pi-plus"
          class="ml-2 p-button-success"
          @click="$router.push('massage/add')"
        />
        <!-- <Button
          label="حذف"
          icon="pi pi-trash"
          @click="deleteAll"
          :disabled="selectedItems.length == 0"
          class="p-button-danger"
        /> -->
      </template>

      <template #right>
        <!-- <Button icon="pi pi-cog" class="p-button-basic ml-2" /> -->
        <Button
          icon="pi pi-download"
          class="p-button-help"
          @click="exportCSV($event)"
        />
        <!-- <Button icon="pi pi-search" class="ml-2" />
        <Button icon="pi pi-times" class="p-button-danger" /> -->
      </template>
    </Toolbar>

    <DataTable
      ref="dt"
      :value="list"
      :paginator="true"
      class="p-datatable-customers"
      :rows="10"
      dataKey="id"
      :rowHover="true"
      :selection.sync="selectedItems"
      :expandedRows.sync="expandedRows"
      :loading="loading"
      :filters="filters"
      paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
      :rowsPerPageOptions="[10, 25, 50, 100]"
      currentPageReportTemplate="show {first} to {last} from {totalRecords}"
    >
      <template #header>
        <div class="table-header">
          Massages Aufführen

          <div style="text-align: left">
            <!-- <MultiSelect
              :value="selectedColumns"
              :options="columns"
              optionLabel="header"
              @input="onToggle"
              placeholder="Select Columns"
              style="width: 20em"
            /> -->
          </div>
        </div>
      </template>
      <template #empty>Keine Daten</template>
      <template #loading>Daten werden geladen, bitte warten... </template>

      <Column :expander="true" headerStyle="width: 3rem" />
      <Column
        filterMatchMode="contains"
        field="id"
        header="ID"
        :sortable="true"
      >
        <template #filter>
          <InputText
            type="number"
            v-model="filters['id']"
            class="p-column-filter"
            placeholder="Search By ID"
          />
        </template>
      </Column>

      <Column filterMatchMode="contains" field="image" header="Image">
        <template #body="slotProps">
          <img
            :src="$baseUploadURL + slotProps.data.image"
            class="profile-pic height-150 width-150 align-items-center"
            style="width: 100px; height: 100px"
          />
        </template>
      </Column>
      <Column
        filterMatchMode="contains"
        field="name.en"
        header="Name (EN)"
        :sortable="true"
      >
        <template #filter>
          <InputText
            v-model="filters['name.en']"
            class="p-column-filter"
            placeholder="Search By Name EN"
            filterMatchMode="contains"
          />
        </template>
        <template #body="slotProps">
          {{ JSON.parse(slotProps.data.name).de }}
        </template>
      </Column>
      <Column
        filterMatchMode="contains"
        field="name.de"
        header="Name (DE)"
        :sortable="true"
      >
        <template #filter>
          <InputText
            v-model="filters['name.de']"
            class="p-column-filter"
            placeholder="Search By Name DE"
            filterMatchMode="contains"
          />
        </template>
        <template #body="slotProps">
          {{ JSON.parse(slotProps.data.name).de }}
        </template>
      </Column>

      <Column
        filterMatchMode="contains"
        field="id"
        bodyStyle="text-align: center; overflow: visible"
      >
        <template #body="slotProps">
          <!-- <Button
            type="button"
            @click="$router.push('admins/roles/' + slotProps.data.id)"
            icon="pi pi-key"
            v-if="slotProps.data.id != 1"
            class="p-button-info ml-2  p-button-rounded"
          ></Button> -->
          <Button
            type="button"
            @click="$router.push('massage/edit/' + slotProps.data.id)"
            icon="pi pi-pencil"
            class="p-button-success p-mr-2 p-button-rounded"
          ></Button>
          <Button
            type="button"
            icon="pi pi-trash"
            @click="deleteItem(slotProps.data.id)"
            class="p-button-warning ml-2 p-button-rounded"
          ></Button>
        </template>
      </Column>

      <template #expansion="slotProps">
        <div class="orders-subtable">
          <DataTable
            :value="adminsList"
            class="p-datatable-customers table table-striped"
          >
            <template #header>
              <div class="table-header">
                Benutzer Aufführen

                <div style="text-align: left"></div>
              </div>
            </template>

            <template #empty>Keine Daten</template>

            <Column filterMatchMode="contains" field="id" header="ID" />
            <Column filterMatchMode="contains" field="fullName" header="Name" />
            <Column filterMatchMode="contains" field="id">
              <template #body="slotProps1">
                <Button
                  type="button"
                  @click="
                    addNew({
                      massageId: slotProps.data.id,
                      adminsId: slotProps1.data.id,
                    })
                  "
                  icon="pi pi-trash"
                  class="p-button-warning p-button-rounded"
                  v-if="
                    slotProps1.data.massageList.find(
                      (el) => el.massageId.id == slotProps.data.id
                    )
                  "
                ></Button>
                <Button
                  type="button"
                  @click="
                    addNew({
                      massageId: slotProps.data.id,
                      adminsId: slotProps1.data.id,
                    })
                  "
                  :disabled="disabledAdd"
                  v-else
                  icon="pi pi-plus"
                  class="p-button-success p-button-rounded"
                ></Button>
              </template>
            </Column>
          </DataTable>

          <DataTable
            :value="slotProps.data.pricesList"
            class="p-datatable-customers table table-striped"
          >
            <template #header>
              <div class="table-header">
                <div style="float: left; display: inline">Prices Aufführen</div>
                <div style="text-align: right">
                  <Button
                    label="Add New Price"
                    icon="pi pi-plus"
                    class="ml-2 p-button-success"
                    @click="openDialog(slotProps.data.id)"
                  />
                </div>
              </div>
            </template>

            <template #empty>Keine Daten</template>

            <Column filterMatchMode="contains" field="id" header="#" />

            <Column field="name.en" header="Name (EN)">
              <template #body="slotProps4">
                <p @click="editPrice(slotProps4.data)">
                
                  {{ JSON.parse(slotProps4.data.name).de }}
                </p>
              </template>
            </Column>
            <Column field="name.de" header="Name (DE)">
              <template #body="slotProps4">
                <p @click="editPrice(slotProps4.data)">
                  {{ JSON.parse(slotProps4.data.name).de }}
                </p>
              </template>
            </Column>
            <Column filterMatchMode="contains" field="minutes" header="Minutes">
              <template #body="slotProps1">
                <input
                  type="number"
                  class="form-control"
                  :name="'minutes_' + slotProps1.data.id"
                  :id="'minutes_' + slotProps1.data.id"
                  v-model.number="slotProps1.data.minutes"
                  style="width: 100%"
                  @change="dx('minutes', slotProps1.data)"
                />
              </template>
            </Column>
            <Column filterMatchMode="contains" field="price" header="Price">
              <template #body="slotProps1">
                <input
                  type="number"
                  class="form-control"
                  :name="'price_' + slotProps1.data.id"
                  :id="'price_' + slotProps1.data.id"
                  v-model.number="slotProps1.data.price"
                  style="width: 100%"
                  @change="dx('price', slotProps1.data)"
                />
              </template>
            </Column>
            <Column
              filterMatchMode="contains"
              field="stoptime"
              header="Stop Time"
            >
              <template #body="slotProps1">
                <input
                  type="number"
                  class="form-control"
                  :name="'stoptime_' + slotProps1.data.id"
                  :id="'stoptime_' + slotProps1.data.id"
                  v-model.number="slotProps1.data.stoptime"
                  style="width: 100%"
                  @change="dx('stoptime', slotProps1.data)"
                />
              </template>
            </Column>
            <Column filterMatchMode="contains" field="id">
              <template #body="slotProps1">
                <Button
                  type="button"
                  @click="deletePrice(slotProps1.data.id)"
                  icon="pi pi-trash"
                  class="p-button-warning p-button-rounded"
                ></Button>
              </template>
            </Column>
          </DataTable>
        </div>
      </template>
    </DataTable>

    <Dialog
      header="Add Price"
      :visible.sync="displayProductsAdd"
      :style="{ width: '50vw' }"
    >
      <div class="p-m-0">
        <div class="mb-3">
          <label for="api_id" class="form-label required">
            Name En
            <span>*</span>
          </label>
          <input class="form-control" v-model="d.name.en" />
        </div>
        <div class="mb-3">
          <label for="api_id" class="form-label required">
            Name DE
            <span>*</span>
          </label>
          <input class="form-control" v-model="d.name.de" />
        </div>

        <div class="mb-3">
          <label for="minutes" class="form-label required">
            Minutes
            <span>*</span>
          </label>
          <input
            class="form-control"
            v-model.number="d.minutes"
            type="number"
          />
        </div>

        <div class="mb-3">
          <label for="stoptime" class="form-label"> StopZeit</label>

          <input
            type="number"
            class="form-control"
            id="stoptime"
            v-model.number="d.stoptime"
          />
        </div>

        <div class="mb-3">
          <label for="price" class="form-label required">
            Price
            <span>*</span>
          </label>
          <input
            class="form-control"
            v-model.number="d.price"
            type="number"
            min="1"
          />
        </div>
      </div>
      <template #footer>
        <Button
          label="Hinzufügen"
          icon="pi pi-check"
          @click="addProducts()"
          autofocus
        />
        <Button
          label="Colose"
          icon="pi pi-times"
          @click="cDialog()"
          class="p-button-text"
        />
      </template>
    </Dialog>

    <Dialog
      header="Add Price"
      :visible.sync="showEditPrice"
      :style="{ width: '50vw' }"
    >
      <div class="p-m-0">
        <div class="mb-3">
          <label for="api_id" class="form-label required">
            Name En
            <span>*</span>
          </label>
          <input class="form-control" v-model="ds.name.en" />
        </div>
        <div class="mb-3">
          <label for="api_id" class="form-label required">
            Name DE
            <span>*</span>
          </label>
          <input class="form-control" v-model="ds.name.de" />
        </div>
      </div>
      <template #footer>
        <Button
          label="Save"
          icon="pi pi-check"
          @click="dx('name',ds);showEditPrice=false"
          autofocus
        />
        <Button
          label="Colose"
          icon="pi pi-times"
          @click="showEditPrice=false"
          class="p-button-text"
        />
      </template>
    </Dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [],
      adminsList: [],
      list4: [],
      selectedItems: [],
      expandedRows: [],
      loading: true,
      filters: {},
      disabledAdd: false,
      displayProductsAdd: false,
      d: {
        minutes: 0,
        price: 0,
        stoptime: 10,
        massageId: null,
        name: { en: null, de: null },
      },
      ds: {
        id:null,
        name: { en: null, de: null },
      },
      showEditPrice: false,
    };
  },
  methods: {
    editPrice(data) {
      this.ds.name = JSON.parse(data.name);
      this.ds.id = data.id;
      this.showEditPrice = true;
    },
    dx(key, val) {
      let obj = {};
      obj[key] = val[key];
      console.log(val);
      // if (key=='name') {
      //   obj[key] = {
      //     ar: val[key]
      //   };
      // }
      this.$http.put(`prices/${val.id}`, obj).then(
        () => {
          this.$toast.add({
            severity: "success",
            summary: "Done Successfully",
            detail: "Added Successfully",
            life: 3000,
          });

          this.getData();
        },
        (err) => {
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail: err.response.data.message,
            life: 3000,
          });
        }
      );
    },
    addProducts() {
      if (
        this.d.name.en &&
        this.d.name.de &&
        this.d.minutes > 0 &&
        this.d.price > 0
      ) {
        this.displayProductsAdd = false;
        this.$http.post(`prices`, this.d).then(
          () => {
            this.$toast.add({
              severity: "success",
              summary: "Done Successfully",
              detail: "Added Successfully",
              life: 3000,
            });
            this.d = {
              minutes: 0,
              price: 0,
              massageId: null,
              stoptime: 10,
              name: { en: null, de: null },
            };

            this.getData();
          },
          (err) => {
            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail: err.response.data.message,
              life: 3000,
            });
          }
        );
      }
    },
    openDialog(id) {
      this.displayProductsAdd = true;
      this.d.massageId = id;
    },
    cDialog() {
      this.displayProductsAdd = false;
      this.d = {
        minutes: 0,
        price: 0,
        massageId: null,
        stoptime: 10,
        name: { en: null, de: null },
      };
    },
    getData() {
      this.$http.get(`massage`).then(
        (response) => {
          this.loading = false;
          this.list = response.data.data;
        },
        (err) => {
          this.loading = false;
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail: err.response.data.message,
            life: 3000,
          });
        }
      );

      this.$http.get(`admins?relations=massageList`).then((response) => {
        this.adminsList = response.data.data;
      });
    },
    onToggle(value) {
      this.selectedColumns = this.columns.filter((col) => value.includes(col));
    },
    exportCSV() {
      this.$refs.dt.exportCSV();
    },
    addNew(body) {
      this.disabledAdd = true;
      this.$http.post(`admins/addMassage`, body).then(
        () => {
          this.$toast.add({
            severity: "success",
            summary: "Done Successfully",
            detail: "Added Successfully",
            life: 3000,
          });
          this.getData();
          this.disabledAdd = false;
        },
        (err) => {
          this.disabledAdd = false;

          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail: err.response.data.message,
            life: 3000,
          });
        }
      );
    },

    deletePrice(id) {
      this.$http.delete(`prices/${id}`).then(
        () => {
          this.getData();
          this.$toast.add({
            severity: "error",
            summary: "Done Successfully",
            detail: "Deleted successfully",
            life: 3000,
          });
        },
        (err) => {
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail: err.response.data.message,
            life: 3000,
          });
        }
      );
    },
    deleteItem(id) {
      this.$confirm.require({
        message: "Are you sure you want to delete records?",
        header: "Yes Delete Record",
        icon: "pi pi-exclamation-triangle",
        accept: () => {
          this.$http.delete(`massage/${id}`).then(
            () => {
              this.getData();
              this.$toast.add({
                severity: "error",
                summary: "Done Successfully",
                detail: "Deleted successfully",
                life: 3000,
              });
            },
            (err) => {
              this.$toast.add({
                severity: "error",
                summary: "Error",
                detail: err.response.data.message,
                life: 3000,
              });
            }
          );
        },
      });
    },
  },
  created() {
    this.getData();

    this.selectedColumns = this.columns;
  },
};
</script>

<style></style>
